import CouponsAPI from 'dashboard/api/pipelines/coupons';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getCoupons(_state) {
    return _state.records;
  },
  getActiveCoupons(_state) {
    return _state.records.filter(coupon => coupon.active);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, { accountId, params = {} }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await CouponsAPI.get(accountId, params);
      commit('SET_ITEMS', response.data?.data || []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, { accountId, coupon }) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await CouponsAPI.create(accountId, coupon);
      commit('ADD_ITEM', response.data?.data || response.data);
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { accountId, id, coupon }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await CouponsAPI.update(accountId, id, coupon);
      commit('UPDATE_ITEM', response.data?.data || response.data);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async ({ commit }, { accountId, id }) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await CouponsAPI.delete(accountId, id);
      commit('DELETE_ITEM', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_ITEMS(_state, items) {
    _state.records = Array.isArray(items) ? items : [];
  },

  ADD_ITEM(_state, item) {
    if (!item?.id) return;
    _state.records.unshift(item);
  },

  UPDATE_ITEM(_state, item) {
    const index = _state.records.findIndex(record => record.id === item.id);
    if (index === -1) return;
    _state.records[index] = { ..._state.records[index], ...item };
  },

  DELETE_ITEM(_state, id) {
    _state.records = _state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
